// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-wrapper{z-index:10000;position:fixed;top:0;bottom:0;left:0;right:0;background-color:#66bfbf;display:flex;justify-content:center;align-items:center}.nav-close-icon{position:absolute;top:0;right:0}.nav-box{font-size:1.8em}.nav-link{display:block;color:#eaf6f6}\n", ""]);
// Exports
module.exports = exports;
